import { getSliders } from '../modules/cms/selectors';

const checkTimeRange = (timeToCheck, startTime, endTime) => {
  const checking = Date.parse(`01/01/1970 ${timeToCheck}`);
  const start = Date.parse(`01/01/1970 ${startTime}`);
  const end = Date.parse(`01/01/1970 ${endTime}`);

  return checking >= start && checking <= end;
};

const findScheduledBanner = (scheduled => {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const currentTime = now.toLocaleTimeString();

  return scheduled.find(item => {
    const {
      noExpiry,
      startDate,
      endDate,
      dailyScheduleEnabled,
      customFrequencyDays,
      timeRanges
    } = item.schedule;

    const isInDateRange = noExpiry || (new Date(startDate) <= now || new Date(endDate) >= now);
    const isDayOfWeek = customFrequencyDays.size ? customFrequencyDays.includes(dayOfWeek) : true;
    let isInTimeRange = true;

    if (dailyScheduleEnabled && timeRanges.size) {
      isInTimeRange = timeRanges
        .find(range => checkTimeRange(currentTime, range.startTime, range.endTime));
    }

    if (!isInDateRange || !isDayOfWeek || !isInTimeRange) {
      return false;
    }

    return true;
  });
});

export function getSliderForCurrentDatetime(state) {
  const allSlides = getSliders(state);

  if (!allSlides.size) {
    return null;
  }

  const rotations = allSlides.getIn(['0', 'rotations']);

  const finalBanners = rotations.map(rotation => {
    if (rotation.scheduled.size === 0) {
      return rotation.default;
    }

    const filtredSchedule = findScheduledBanner(rotation.scheduled);

    return filtredSchedule ? filtredSchedule.banner : rotation.default;
  });

  return finalBanners.filter(item => item);
}

export default getSliderForCurrentDatetime;
